// extracted by mini-css-extract-plugin
export default {"discoverPagination":"DiscoverPagination_discoverPagination__krPDz"};